import { apiAuth, apiResponseType } from ".";

export const getTimeEntriesData = (
  page: number = 1,
  unity_id?: string,
  name?: string,
  filters?: Record<string, string>
): apiResponseType => {
  const params = new URLSearchParams({ page: String(page) });
  if (unity_id) params.set("unity_id", unity_id);
  if (name) params.set("name", name);
  // `period` é só do front (atalho de datas); o backend recebe start_at/end_at.
  Object.entries(filters ?? {}).forEach(([key, value]) => {
    if (value !== "" && value !== undefined && key !== "period") {
      params.set(key, key.endsWith("_at") ? value.replace("T", " ") : value);
    }
  });
  return apiAuth.get(`time-entries?${params.toString()}`);
};

export const searchTimeEntriesData = (params: {
  name: string;
  unity_id?: string;
}): apiResponseType =>
  apiAuth.get(
    `time-entries?name=${params.name}${
      params.unity_id ? `` : ""
    }`
  );

export const getShowTimeEntry = (uuid: string) =>
  apiAuth.get(`time-entries/${uuid}/show`) as apiResponseType;

export const postClockIn = (data) =>
  apiAuth.postForm("/time-entries/clock-in", data) as apiResponseType;

export const postManualAdjustment = (data) =>
  apiAuth.postForm("/time-entries/manual-adjustment", data) as apiResponseType;

export const getTodayStatus = () =>
  apiAuth.get("time-entries/today-status") as apiResponseType;

export const getMyTimeEntriesData = (page: number = 1): apiResponseType =>
  apiAuth.get(`time-entries/my-entries?page=${page}`);

export const getHourBank = () =>
  apiAuth.get("time-entries/hour-bank") as apiResponseType;

export const updateTimeEntryLocation = (
  uuid: string,
  data: { latitude: number; longitude: number; justification: string }
) => apiAuth.post(`time-entries/${uuid}/update-location`, data) as apiResponseType;
